import { useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import { Link, useNavigate } from 'react-router';

import { useGetUser, useLogOut } from '@/api';
import { ArrowIcon } from '@/components/icons/main-block';
import { LogOutIcon, TrashIcon } from '@/components/icons/profile';
import { Button } from '@/components/shared/Button';
import { Divider } from '@/components/shared/Divider/Divider.tsx';
import { ModalBase } from '@/components/shared/Modal/ModalBase.tsx';
import { UnderDev } from '@/components/shared/UnderDev/UnderDev.tsx';
import { isMobile } from '@/constants';
import { appRoutes } from '@/routes/app-routes.ts';
import { useAuthStore, useModalStore } from '@/store';

import cn from './styles.module.sass';

export const Profile = () => {
    const { data: userData, isLoading: isUserLoading } = useGetUser();
    const { mutateAsync: logOut, isSuccess } = useLogOut();
    const { setIsOpen, setShowSignUp, setIsProfileDeletionOpen } = useModalStore();
    const navigate = useNavigate();

    const [isActivationOpen, setIsActivationOpen] = useState(false);

    const { isAuth, token } = useAuthStore();

    const fullname = userData ? `${userData.firstname} ${userData.lastname}` : '';

    const FullNameWithSkeleton = isUserLoading ? <Skeleton width={200} /> : fullname;

    const handleLogOut = async () => {
        await logOut();
        if (isSuccess) {
            navigate('/');
        }
    };

    const handleClick = () => {
        if (isAuth) {
            setIsActivationOpen(true);
        } else {
            setShowSignUp(false);
            setIsOpen(true);
        }
    };

    return (
        <div className={cn.container}>
            <div className={cn.authBlock}>
                <h2>{token || isAuth ? FullNameWithSkeleton : 'Войти в профиль'}</h2>
                {!(isAuth || token) && (
                    <Button onClick={handleClick} className={cn.button}>
                        {isAuth || token ? 'Подтвердить профиль' : 'Войти или зарегистрироваться'}
                    </Button>
                )}
                {/*{true &&*/}
                {/*    (false ? (*/}
                {/*        <Skeleton width={111} height={19} />*/}
                {/*    ) : (*/}
                {/*        <div className={cn.badgeWrapper}>*/}
                {/*            <ProfileStatusBadge active={false} />*/}
                {/*        </div>*/}
                {/*    ))}*/}
            </div>
            <div className={cn.links}>
                {isAuth || token ? (
                    <>
                        <Link to={appRoutes.loyaltyProgram}>Как зарабатывать{ArrowIcon}</Link>
                        <Divider />
                        <Link to={appRoutes.settings}>Настройки{ArrowIcon}</Link>
                        <Divider />
                        <Link to={appRoutes.help}>Помощь{ArrowIcon}</Link>
                        <Divider />
                        {isMobile && (
                            <>
                                <Link to={appRoutes.about}>О приложении{ArrowIcon}</Link>
                                <Divider />
                            </>
                        )}
                    </>
                ) : (
                    <Link to={appRoutes.help}>Помощь{ArrowIcon}</Link>
                )}
            </div>
            {isAuth && (
                <div className={cn.actions}>
                    <Button
                        onClick={handleLogOut}
                        background="transparent"
                        className={cn.actionBtn}
                    >
                        {LogOutIcon} Выйти из профиля
                    </Button>
                    <Button
                        onClick={() => setIsProfileDeletionOpen(true)}
                        background="transparent"
                        className={cn.actionBtn}
                    >
                        {TrashIcon} Удалить профиль
                    </Button>
                </div>
            )}
            {isAuth && (
                <ModalBase
                    isNotAuth={false}
                    isOpen={isActivationOpen}
                    onClose={() => setIsActivationOpen(false)}
                >
                    <div className={cn.underDev}>
                        <h2>Подтвердить профиль</h2>
                        <UnderDev classname={cn.underDevContainer} />
                    </div>
                    {/*<ProfileActivationContent />*/}
                </ModalBase>
            )}
        </div>
    );
};
